// NPM
import React from 'react';
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// Services
import renderService from 'services/renderService';

// Components
import FacebookButton from 'components/Social/FacebookButton';
import TwitterButton from 'components/Social/TwitterButton';

function ShareSection() {
  // State
  const campaignConfig = useSelector(state => state.campaignConfig.value);

  if(!renderService.canRender([campaignConfig])) {
    return null;
  }

  return (
    <div className="ShareSection Signal__section">
      <div className="ShareSection__holder">
        <div className="ShareSection__title">
          { _.get(campaignConfig, `social.shareSection.title`) }
        </div>
        <div className="ShareSection__options">
          <FacebookButton />
          <TwitterButton />
        </div>
      </div>
    </div>
  )

}

export default ShareSection;